module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_8003.0b2695be.png";